// KycStatusBadge.js — Reusable status badge for KYC case states
// Maps each CASE_STATES value to a coloured pill

import React from 'react';

const STATUS_CONFIG = {
  draft:                   { label: 'Draft',                   bg: 'bg-gray-100',    text: 'text-gray-700',    dot: 'bg-gray-400'    },
  submitted:               { label: 'Submitted',               bg: 'bg-blue-100',    text: 'text-blue-700',    dot: 'bg-blue-500'    },
  in_review:               { label: 'In Review',               bg: 'bg-yellow-100',  text: 'text-yellow-700',  dot: 'bg-yellow-500'  },
  information_requested:   { label: 'Info Requested',           bg: 'bg-indigo-100',  text: 'text-indigo-700',  dot: 'bg-indigo-500'  },
  screening:               { label: 'Screening',               bg: 'bg-purple-100',  text: 'text-purple-700',  dot: 'bg-purple-500'  },
  risk_assessment:         { label: 'Risk Assessment',          bg: 'bg-orange-100',  text: 'text-orange-700',  dot: 'bg-orange-500'  },
  pending_approval:        { label: 'Pending Approval',         bg: 'bg-amber-100',   text: 'text-amber-700',   dot: 'bg-amber-500'   },
  approved:                { label: 'Approved',                 bg: 'bg-green-100',   text: 'text-green-700',   dot: 'bg-green-500'   },
  conditionally_approved:  { label: 'Conditionally Approved',   bg: 'bg-teal-100',    text: 'text-teal-700',    dot: 'bg-teal-500'    },
  rejected:                { label: 'Rejected',                 bg: 'bg-red-100',     text: 'text-red-700',     dot: 'bg-red-500'     },
  expired:                 { label: 'Expired',                  bg: 'bg-stone-100',   text: 'text-stone-700',   dot: 'bg-stone-400'   },
  suspended:               { label: 'Suspended',                bg: 'bg-rose-100',    text: 'text-rose-700',    dot: 'bg-rose-500'    },
  closed:                  { label: 'Closed',                   bg: 'bg-slate-100',   text: 'text-slate-700',   dot: 'bg-slate-400'   },
};

const SIZE_CLASSES = {
  xs: 'px-1.5 py-0.5 text-[10px]',
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
  lg: 'px-3 py-1.5 text-sm',
};

const DOT_SIZES = {
  xs: 'w-1 h-1',
  sm: 'w-1.5 h-1.5',
  md: 'w-2 h-2',
  lg: 'w-2 h-2',
};

const KycStatusBadge = ({ status, size = 'sm', showDot = true, className = '' }) => {
  const config = STATUS_CONFIG[status] || {
    label: status || 'Unknown',
    bg: 'bg-gray-100',
    text: 'text-gray-600',
    dot: 'bg-gray-400',
  };

  return (
    <span
      className={`inline-flex items-center gap-1 font-medium rounded-full ${config.bg} ${config.text} ${SIZE_CLASSES[size] || SIZE_CLASSES.sm} ${className}`}
    >
      {showDot && (
        <span className={`rounded-full ${config.dot} ${DOT_SIZES[size] || DOT_SIZES.sm} flex-shrink-0`} />
      )}
      {config.label}
    </span>
  );
};

export default KycStatusBadge;
